export default __webpack_public_path__ + "ember.c9fe472e.png";